import { PlanFeatures } from "@Light/utils/planFeatures";
import headerImageBattery from "../../../../public/images/header-battery.jpg";
import headerImageEV from "../../../../public/images/header-ev.jpg";
import headerImageSimple from "../../../../public/images/header-simple.jpg";
import headerImageSolar from "../../../../public/images/header-solar.jpg";

export const getPlanHeaderImageForFeatures = (features: PlanFeatures) => {
  if (features.solarBuyback) {
    return headerImageSolar;
  }
  if (features.vehicleCharging) {
    return headerImageEV;
  }
  if (features.storageCredit) {
    return headerImageBattery;
  }
  return headerImageSimple;
};
